import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {Layout, Select, Input} from "antd";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../../api/http-post";
import {fetchDataEntity} from "../../../../api/entity-data";

const {TextArea} = Input;
const {Content} = Layout;
const {Option} = Select;

class SettingWageAttributeMappingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Products: [],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getModuleList = () => {
        let ls = [];
        for (let i in this.state.Modules) {
            let row = this.state.Modules[i];
            if (row.org === this.state.newEntry.org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }

    getCircleList = () => {
        let ls = [];
        ls.push({
            key: "week",
            val: "Week",
        });
        ls.push({
            key: "month",
            val: "Month",
        });

        return ls;
    }

    render() {
        const modulesOptions = this.getModuleList();
        const companyOptions = this.getCompanyList();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Attribute Mapping</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"WageRuleAttributeMapping"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "project",
                                    dataType: "option",
                                    required: true,
                                    label: "Project & Contract",
                                    options: modulesOptions,
                                },
                                {
                                    name: "site",
                                    dataType: "string",
                                    required: true,
                                    label: "Site",
                                    options: []
                                },
                                {
                                    name: "designation",
                                    dataType: "string",
                                    required: true,
                                    label: "Designation",
                                    options: []
                                },
                                {
                                    name: "paymethod",
                                    dataType: "string",
                                    required: true,
                                    label: "PayMethod",
                                    options: []
                                },

                                {
                                    name: "idnumber",
                                    dataType: "string",
                                    required: true,
                                    label: "Id Number",
                                    options: []
                                },
                                {
                                    name: "empNumber",
                                    dataType: "string",
                                    required: true,
                                    label: "Emp Number",
                                    options: []
                                },
                                {
                                    name: "name",
                                    dataType: "string",
                                    required: true,
                                    label: "Name",
                                    options: []
                                },

                                {
                                    name: "terminationdate",
                                    dataType: "string",
                                    required: true,
                                    label: "TerminationDate",
                                    options: []
                                },
                                {
                                    name: "terminationcode",
                                    dataType: "string",
                                    required: true,
                                    label: "TerminationCode",
                                    options: []
                                },
                                {
                                    name: "terminationreason",
                                    dataType: "string",
                                    required: true,
                                    label: "TerminationReason",
                                    options: []
                                },

                                {
                                    name: "bankname",
                                    dataType: "string",
                                    required: true,
                                    label: "BankName",
                                    options: []
                                },
                                {
                                    name: "bankacc",
                                    dataType: "string",
                                    required: true,
                                    label: "BankAcc",
                                    options: []
                                },

                                {
                                    name: "bankbranchcode",
                                    dataType: "string",
                                    required: true,
                                    label: "BankBranchCode",
                                    options: []
                                },
                                {
                                    name: "phone",
                                    dataType: "string",
                                    required: true,
                                    label: "Phone",
                                    options: []
                                },
                                {
                                    name: "contractperiod",
                                    dataType: "string",
                                    required: true,
                                    label: "ContractPeriod",
                                    options: []
                                },


                                {
                                    name: "contractstart",
                                    dataType: "string",
                                    required: true,
                                    label: "ContractStart",
                                    options: []
                                },
                                {
                                    name: "contractend",
                                    dataType: "string",
                                    required: true,
                                    label: "Contract End",
                                    options: []
                                },
                                {
                                    name: "payas",
                                    dataType: "string",
                                    required: true,
                                    label: "Pay As",
                                    options: []
                                },

                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "project", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"WageRuleAttributeMapping"}
                            addFormText={"Attribute Mapping Rule Setup"}
                            stepTitle={"Set Up new attribute mapping rule"}
                        />

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(SettingWageAttributeMappingPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

